function AdminHomePage() {
  return (
    <div>
      <h2>Consola de Administración</h2>
      <p>Bienvenido al panel de administración de EduCertify.</p>
      {/* Aquí irán los enlaces a las diferentes secciones de administración */}
    </div>
  );
}

export default AdminHomePage;